import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Point } from '@printu/geom';
import { getViewportVirtualToCanvas } from '@printu/viewport';
import { useHandleDrag } from 'app/views/hooks/useHandleDrag';
import { Capabilities } from 'app/utils/Capabilities';
import { toPx } from 'app/utils/DOM';
import { noop } from 'app/utils/function';
const Consts = {
    markerSize: {
        desktop: {
            width: '12px',
            height: '12px',
            marginLeft: '-6px',
            marginTop: '-6px',
        },
        mobile: {
            width: '24px',
            height: '24px',
            marginLeft: '-12px',
            marginTop: '-12px',
        },
    },
};
const getWrapperEl = () => document.querySelector('.interactions-wrapper');
export const Edit = (props) => {
    const { handles, onHandleChanged } = props;
    const viewport = useSelector((state) => state.viewport);
    const containerRef = React.useRef(getWrapperEl());
    const handlers = React.useMemo(() => ({ onDragStart: noop, onDrag: onHandleChanged, onDragEnd: noop }), [onHandleChanged]);
    useEffect(() => {
        containerRef.current = getWrapperEl();
    }, []);
    useHandleDrag(containerRef, handlers, { workspace: 'canvas' });
    if (!handles) {
        return null;
    }
    const markerSize = Consts.markerSize[Capabilities.shared.isMobileDevice ? 'mobile' : 'desktop'];
    return (React.createElement(React.Fragment, null, Object.entries(handles).map(([id, handle]) => {
        const position = getViewportVirtualToCanvas(viewport, new Point(handle.current));
        return (React.createElement("div", { className: "handle user-select-none touch-action-none", id: id, key: id, style: Object.assign({ position: 'absolute', left: toPx(position.x), top: toPx(position.y), background: 'white', border: '2px solid #3399ff', borderRadius: '50%' }, markerSize) }));
    })));
};
